export const SecondLevelMenus = ['FontFamily']
export const FirstLevelMenus = ['Background']

export enum SubMenuType {
  FONT_FAMILY = 'FontFamily',
  BACKGROUND = 'Background',
  COLOR = 'Color',
}

export const editorFonts = [
  {
    name: 'Roboto',
    preview:
      'https://font-public.canva.com/YACgEev4gKc/0/thumbnail3539468006015936417.786a5ed94cf61f05978893c9088a06ea.png',
  },
  {
    name: 'Quicksand',
    preview:
      'https://font-public.canva.com/YADWjpfPmdk/0/thumbnail1564020220251902443.bc4d1dede1fc33ec1e227ccfbc723b00.png',
  },

  {
    name: 'Josefin Sans',
    preview:
      'https://font-public.canva.com/YADWjoIs6hY/0/thumbnail5311368174505054542.97ad47e884b96eb86f0a0f6b9abb0e61.png',
  },
  {
    name: 'Arimo',
    preview:
      'https://font-public.canva.com/YACgEZ1cb1Q/0/thumbnail2753710016227887457.6dfe783f5d32581a0de7b11c49badc89.png',
  },
  {
    name: 'Open Sans',
    preview:
      'https://font-public.canva.com/YAD7QhG2T6o/0/thumbnail4397746033903160930.50a02b6e1eabffa186ed7d1592726fe7.png',
  },
]

export const gradients = [
  {
    angle: 0,
    colors: ['#00c3ff', '#ffff1c'], //linear-gradient(to right, #00c3ff, #ffff1c)
  },
  {
    angle: 0,
    colors: ['#8e2de2', '#4a00e0'], //linear-gradient(to right, #00c3ff, #ffff1c)
  },
  {
    angle: 0,
    colors: ['#c0392b', '#8e44ad'], //linear-gradient(to right, #00c3ff, #ffff1c)
  },
  {
    angle: 0,
    colors: ['#ff00cc', '#333399'], //linear-gradient(to right, #00c3ff, #ffff1c)
  },
  {
    angle: 0,
    colors: ['#ff4b1f', '#1fddff'], //linear-gradient(to right, #00c3ff, #ffff1c)
  },
  {
    angle: 0,
    colors: ['#6a3093', '#a044ff'], //linear-gradient(to right, #00c3ff, #ffff1c)
  },
  {
    angle: 0,
    colors: ['#fc00ff', '#00dbde'], //linear-gradient(to right, #00c3ff, #ffff1c)
  },
  {
    angle: 0,
    colors: ['#ff0084', '#33001b'], //linear-gradient(to right, #00c3ff, #ffff1c)
  },
  {
    angle: 0,
    colors: ['#43cea2', '#185a9d'], //linear-gradient(to right, #00c3ff, #ffff1c)
  },
]
